module.exports = new __parcel__URL__("meme-1.f2dd8c30.png").toString();